/**************************************************
 * Nombre:       IconoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Typography} from "@mui/material";
import {iniciarChatWass} from "../../../Utilidades/iniciarChatWass";

const IconoTexto = ({Icono, texto}) => {

    return (
        <Typography
            onClick={() => iniciarChatWass({mensaje: 'Hola Pet Suplice'})}
            sx={{fontSize: 14, cursor: 'pointer'}}>
           <span>
               <Icono sx={{fill: '#fff', width: 18, height: 18, pr: 1, mt: 0.5, mb: -0.5}}/>
           </span>
            {texto}
        </Typography>
    )

}
export default IconoTexto